// =============================================================
//  H.Λ.R.V.E.R — SITE CONTENT  (edit this file to update the site)
//  Only your own uploaded assets are used below.
//  Keep the "Λ" character exactly as-is (do not replace with A).
// =============================================================

export const BRAND = {
  name: "H.\u039B.R.V.E.R",
  phrase: "ART\u2019S TRUE FORM",
  tagline: "MUSIC \u2022 VISUALS \u2022 CULTURE",
  copyright: "\u00A9 H.\u039B.R.V.E.R",
};

// ---- YOUR UPLOADED VISUALS ----------------------------------
const A = "https://customer-assets-v7afamib.emergentagent.net/job_harver-archive/artifacts/";
const B = "https://customer-assets-39nsmqrw.emergentagent.net/job_dc9bf802-9ac3-4563-8340-d5abfda4b445/artifacts/";
export const ASSETS = {
  portraitSeated: B + "xs7cduts_A23340EC-67E2-4E7F-BC6D-18DC8B4F3539.png", // hi-res seated, industrial ceiling
  portraitCar: A + "zx40kpbe_IMG_5960.webp",         // driving / music-video still
  coverCant: A + "xi22okxv_copy_E5D718B9-8950-43CF-9761-5F09602D869D.jpeg", // "CAN'T"
  coverTrust: A + "o6riqtkk_5309A0E0-5BAD-4E69-BCA7-2EE2466A69CE.png",       // "TRUST"
  coverBmdf: A + "zb8gcjed_copy_42CC456E-0C01-48EB-AB8E-729103D8C85B.jpeg",  // "BABY MAMA DRAMA FREE"
  coverRaindrop: A + "mphoito2_copy_5280F601-D0BE-4BEE-BF37-08C89BACED3C.jpeg", // "RAINDROP feat Y-Millz"
  coverCandle: A + "i6cf6l7l_copy_8E3E936B-DF81-4678-8164-F93E1AD6D8D9.jpeg",   // "CANDLE LIT"
  filmMov: A + "tvn8vpap_copy_26F54023-B36D-4943-8E7F-09EE0E51A887.mov",     // official film clip
  audioRaindrop: A + "eu6gexmr_Harver%20feat%20Y.Millz%20Raindrop_Mastered_042223BB-5B96-4954-B857-7922FF1C9F10.wav",
  audioTrust: A + "32lwmw4a_3.%20Trust.wav",
  audioBmdf: A + "lm17a5ff_0.%20B.M.D.F.wav",
  audioCandle: A + "324fuh5n_H.A.R.V.E.R%20Candle%20Lit%20Mastered.wav",
  audioCant: A + "szvf0jsg_Can%E2%80%99t_Mastered_7A0B2EB6-41CC-4623-8C49-4A9EA4939515.wav",
};

// ---- OFFICIAL LINKS (real) ----------------------------------
export const LINKS = {
  instagram: "https://instagram.com/h.a.r.v.e.r._",
  tiktok: "https://tiktok.com/@h.a.r.v.e.r",
  youtube: "https://youtube.com/h.a.r.v.e.r",
  facebook: "https://facebook.com/1H9vko9HqD",
  spotify: "https://open.spotify.com/artist/27qRhn9YE1BZyWtbZEMJhQ",
  apple: "https://music.apple.com/us/artist/h-a-r-v-e-r/6797949694",
};

export const NAV = [
  { label: "H.\u039B.R.V.E.R", target: "hero" },
  { label: "MUSIC", target: "music" },
  { label: "VISUALS", target: "visuals" },
  { label: "ARCHIVE", target: "archive" },
  { label: "SHOP", target: "objects" },
  { label: "ABOUT", target: "about" },
];

// ---- MUSIC (add a new object here for each release) ----------
export const MUSIC = [
  {
    id: "r_raindrop",
    title: "RAINDROP",
    featured: "feat. Y-MILLZ",
    date: "2026",
    cover: ASSETS.coverRaindrop,
    links: { spotify: LINKS.spotify, apple: LINKS.apple },
  },
  {
    id: "r_candle",
    title: "CANDLE LIT",
    featured: "H.\u039B.R.V.E.R",
    date: "2026",
    cover: ASSETS.coverCandle,
    links: { spotify: LINKS.spotify, apple: LINKS.apple },
  },
  {
    id: "r01",
    title: "CAN\u2019T",
    featured: "H.\u039B.R.V.E.R",
    date: "2026",
    cover: ASSETS.coverCant,
    links: { spotify: LINKS.spotify, apple: LINKS.apple },
  },
  {
    id: "r02",
    title: "TRUST",
    featured: "H.\u039B.R.V.E.R",
    date: "2024",
    cover: ASSETS.coverTrust,
    links: { spotify: LINKS.spotify, apple: LINKS.apple },
  },
];

// ---- VISUALS / VIDEOS ---------------------------------------
// Paste a YouTube/Vimeo EMBED url in `embed`, or a direct .mp4 in `file`.
export const VIDEOS = [
  {
    id: "v00",
    title: "H.\u039B.R.V.E.R \u2014 OFFICIAL FILM",
    type: "Music Video",
    year: "2026",
    thumb: ASSETS.portraitCar,
    embed: "",
    file: ASSETS.filmMov,
  },
  {
    id: "v01",
    title: "CAN\u2019T",
    type: "Music Video",
    year: "2026",
    thumb: ASSETS.coverCant,
    embed: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    file: "",
  },
  {
    id: "v02",
    title: "TRUST",
    type: "Visualizer",
    year: "2024",
    thumb: ASSETS.coverTrust,
    embed: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    file: "",
  },
  {
    id: "v03",
    title: "STUDIO SESSIONS",
    type: "Behind The Scenes",
    year: "2026",
    thumb: ASSETS.portraitSeated,
    embed: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    file: "",
  },
];

// ---- ARCHIVE / PHOTOGRAPHY (span: tall | wide | square) ------
export const ARCHIVE = [
  { id: "p1", src: ASSETS.portraitSeated, tag: "Portrait", span: "tall" },
  { id: "p2", src: ASSETS.coverCant, tag: "Cover \u2014 CAN\u2019T", span: "square" },
  { id: "p3", src: ASSETS.portraitCar, tag: "Film Still", span: "tall" },
  { id: "p4", src: ASSETS.coverTrust, tag: "Cover \u2014 TRUST", span: "square" },
];

// ---- OBJECTS / SHOP -----------------------------------------
export const OBJECTS = [
  {
    id: "o1",
    name: "CAN\u2019T \u2014 VINYL",
    price: "$45",
    desc: "Limited numbered pressing. Chrome-foil sleeve.",
    image: ASSETS.coverCant,
    sizes: ["ONE SIZE"],
    buy: "#",
  },
  {
    id: "o2",
    name: "TRUST \u2014 VINYL",
    price: "$45",
    desc: "Limited pressing. Includes lyric insert.",
    image: ASSETS.coverTrust,
    sizes: ["ONE SIZE"],
    buy: "#",
  },
  {
    id: "o3",
    name: "TRUE FORM \u2014 PRINT",
    price: "$90",
    desc: "Museum-grade giclée portrait. Edition of 100.",
    image: ASSETS.portraitSeated,
    sizes: ["A2", "A1"],
    buy: "#",
  },
  {
    id: "o4",
    name: "NIGHT DRIVE \u2014 PRINT",
    price: "$90",
    desc: "Film-still giclée. Edition of 100.",
    image: ASSETS.portraitCar,
    sizes: ["A2", "A1"],
    buy: "#",
  },
];

// ---- TRANSMISSIONS ------------------------------------------
export const TRANSMISSIONS = [
  {
    id: "t1",
    code: "TX \u2014 013",
    date: "SIGNAL ACTIVE",
    title: "Unreleased snippet \u2014 next chapter",
    desc: "A fragment from what\u2019s coming. Playing to no one and everyone.",
    locked: false,
  },
  {
    id: "t3",
    code: "TX \u2014 014",
    date: "ENCRYPTED",
    title: "Limited drop \u2014 coordinates pending",
    desc: "Fan-exclusive object. Access reveals soon for those inside the world.",
    locked: true,
  },
];

export const STATEMENT = {
  chapters: [
    {
      no: "01",
      title: "THE WORLD",
      body: "H.\u039B.R.V.E.R exists at the intersection of music, visual storytelling, fashion, culture and experience. ART\u2019S TRUE FORM is more than a phrase \u2014 it is the world behind the music.",
    },
    {
      no: "02",
      title: "THE FORM",
      body: "No face. No noise. Only the work in its truest form \u2014 released as sound, image, object and transmission for those who choose to enter.",
    },
    {
      no: "03",
      title: "THE INVITATION",
      body: "This is not a page about an artist. It is a door into a universe. Return often. The signal keeps moving.",
    },
  ],
};

// ---- STORE (buy singles / album via Stripe) -----------------
export const STORE = {
  album: {
    id: "album",
    name: "BABY MAMA DRAMA FREE",
    type: "Album",
    price: "$9.99",
    lookup_key: "harver_album",
    cover: ASSETS.coverBmdf,
    desc: "The full album. Instant digital download.",
    preview: ASSETS.audioBmdf,
    download: ASSETS.audioBmdf,
  },
  singles: [
    { id: "raindrop", name: "RAINDROP", featured: "feat. Y-MILLZ", price: "$1.00", lookup_key: "harver_single_raindrop", cover: ASSETS.coverRaindrop, preview: ASSETS.audioRaindrop, download: ASSETS.audioRaindrop },
    { id: "candle", name: "CANDLE LIT", price: "$1.00", lookup_key: "harver_single_candlelit", cover: ASSETS.coverCandle, preview: ASSETS.audioCandle, download: ASSETS.audioCandle },
    { id: "cant", name: "CAN\u2019T", price: "$1.00", lookup_key: "harver_single_cant", cover: ASSETS.coverCant, preview: ASSETS.audioCant, download: ASSETS.audioCant },
    { id: "trust", name: "TRUST", price: "$1.00", lookup_key: "harver_single_trust", cover: ASSETS.coverTrust, preview: ASSETS.audioTrust, download: ASSETS.audioTrust },
  ],
};

// Order: discovery-first (Instagram, TikTok, YouTube), then streams, Facebook secondary.
export const SOCIALS = [
  { label: "Instagram", href: LINKS.instagram, icon: "instagram" },
  { label: "TikTok", href: LINKS.tiktok, icon: "tiktok" },
  { label: "YouTube", href: LINKS.youtube, icon: "youtube" },
  { label: "Spotify", href: LINKS.spotify, icon: "spotify" },
  { label: "Apple Music", href: LINKS.apple, icon: "apple" },
  { label: "Facebook", href: LINKS.facebook, icon: "facebook", secondary: true },
];

// Streaming CTAs
export const LISTEN = [
  { key: "spotify", label: "Spotify", href: LINKS.spotify, icon: "spotify" },
  { key: "apple", label: "Apple Music", href: LINKS.apple, icon: "apple" },
];

export const PLATFORMS = LISTEN;
